/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxFiles: NonNullable<unknown> }} Errors_Toomanyfilesselected3Inputs */

const en_errors_toomanyfilesselected3 = /** @type {(inputs: Errors_Toomanyfilesselected3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot select more than ${i?.maxFiles} files at once`)
};

/**
* | output |
* | --- |
* | "Cannot select more than {maxFiles} files at once" |
*
* @param {Errors_Toomanyfilesselected3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_toomanyfilesselected3 = /** @type {((inputs: Errors_Toomanyfilesselected3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Toomanyfilesselected3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_toomanyfilesselected3(inputs)
});
export { errors_toomanyfilesselected3 as "errors_tooManyFilesSelected" }